import { render } from "./general-comment.vue?vue&type=template&id=e5ab370e"
import script from "./general-comment.vue?vue&type=script&lang=js"
export * from "./general-comment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__